export default {
  title: "Dienstleister",
  description: "Verwalten Sie Ihre Hochzeitsdienstleister",
  subtitle: "Dienstleister hinzufügen und verwalten",
  addVendor: "Dienstleister hinzufügen",
  editVendor: "Dienstleister bearbeiten",
  deleteVendor: "Dienstleister löschen",
  noVendors: "Keine Dienstleister gefunden",
  addFirstVendor: "Fügen Sie Ihren ersten Dienstleister hinzu",
  hired: "Beauftragt",
  engagedVendors: "Beauftragte Dienstleister",
  noEngagedVendors: "Noch keine beauftragten Dienstleister",
  allVendors: "Alle Dienstleister",
  more: "mehr",
  vendorDeleted: "Dienstleister erfolgreich gelöscht",
  vendorCreated: "Dienstleister erfolgreich erstellt",
  vendorUpdated: "Dienstleister erfolgreich aktualisiert",
  totalVendors: "{{count}} Dienstleister",
  
  categories: {
    venue: "Location",
    religious_venue: "Religiöse Stätte",
    city_hall: "Rathaus",
    catering: "Catering",
    photography: "Fotografie",
    videography: "Videografie",
    music: "Musik",
    florist: "Florist",
    cake: "Torte",
    dress: "Kleid",
    suit: "Anzug",
    hair_makeup: "Frisur & Make-up",
    decoration: "Dekoration",
    transportation: "Transport",
    flowers: "Blumen",
    transport: "Transport",
    beauty: "Schönheit",
    other: "Sonstiges",
    select: "Kategorie auswählen",
    none: "Keine",
    photos: "Fotos",
    preparation: "Vorbereitung",
    reminder: "Erinnerung",
    task: "Aufgabe",
    vendor: "Dienstleister",
    vendors: "Dienstleister",
    custom: "Benutzerdefiniert",
    photographer: "Fotograf",
    caterer: "Caterer",
    attire: "Kleidung"
  },

  form: {
    name: "Name",
    category: "Kategorie",
    contact: "Kontakt",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    website: "Webseite",
    price: "Preis",
    notes: "Notizen",
    rating: "Bewertung",
    status: "Status",
    statusHelper: "Der Status bestimmt die Budget- und Aufgabenverwaltung.",
    contactName: "Kontaktname",
    deposit: "Anzahlung",
    depositPaid: "Anzahlung bezahlt",
    contractSigned: "Vertrag unterzeichnet",
    country: "Land",
    errors: {
      nameRequired: "Name ist erforderlich",
      categoryRequired: "Kategorie ist erforderlich",
      statusRequired: "Status ist erforderlich",
      pricePositive: "Preis muss positiv sein",
      depositPositive: "Anzahlung muss positiv sein",
      capacityPositive: "Kapazität muss eine positive Zahl sein"
    },
    new: "Neuer Dienstleister",
    edit: "Dienstleister bearbeiten",
    title: "Dienstleister-Details",
    namePlaceholder: "Dienstleistername",
    company: "Firma",
    categoryPlaceholder: "Kategorie auswählen",
    emailPlaceholder: "E-Mail-Adresse",
    phonePlaceholder: "Telefonnummer",
    websitePlaceholder: "Webseiten-URL",
    addressPlaceholder: "Dienstleisteradresse",
    notesPlaceholder: "Zusätzliche Notizen",
    submit: "Speichern",
    cancel: "Abbrechen",
    confirmCancel: "Abbrechen",
    contactInfo: "Kontaktinformationen",
    capacity: "Maximale Kapazität",
    capacityPlaceholder: "Maximale Anzahl an Personen",
    contactNamePlaceholder: "Kontaktname",
    description: "Beschreibung",
    dueDate: "Fälligkeitsdatum",
    priority: "Priorität"
  },

  status: {
    contacted: "Kontaktiert",
    quote: "Angebot erhalten",
    booked: "Gebucht",
    hired: "Beauftragt",
    deposit_paid: "Anzahlung bezahlt",
    paid: "Bezahlt",
    cancelled: "Storniert",
    to_contact: "Zu kontaktieren",
    meeting_scheduled: "Termin vereinbart",
    meetingScheduled: "Termin vereinbart",
    quote_received: "Angebot erhalten",
    quoteReceived: "Angebot erhalten",
    depositPaid: "Anzahlung bezahlt",
    completed: "Abgeschlossen",
    researching: "Recherchierend",
    confirmed: "Bestätigt",
    pending: "Ausstehend",
    declined: "Abgelehnt"
  },

  actions: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    contact: "Kontaktieren",
    book: "Buchen",
    add: "Hinzufügen",
    addLong: "Neuen Dienstleister hinzufügen",
    importGuests: "Gäste importieren"
  },

  messages: {
    vendorAdded: "Dienstleister erfolgreich hinzugefügt",
    vendorUpdated: "Dienstleister erfolgreich aktualisiert",
    vendorDeleted: "Dienstleister erfolgreich gelöscht",
    error: "Ein Fehler ist aufgetreten",
    createSuccess: "Dienstleister erfolgreich hinzugefügt",
    updateSuccess: "Dienstleister erfolgreich aktualisiert",
    deleteSuccess: "Dienstleister erfolgreich gelöscht",
    deleteConfirm: "Sind Sie sicher, dass Sie diesen Dienstleister löschen möchten?"
  },

  confirm: {
    delete: "Sind Sie sicher, dass Sie diesen Dienstleister löschen möchten?",
    budgetRemoval: {
      title: "Budget entfernen",
      message: "Sind Sie sicher, dass Sie das mit diesem Dienstleister verbundene Budget löschen möchten?",
      confirm: "Ja, löschen",
      cancel: "Abbrechen"
    }
  },

  confirmations: {
    delete: "Sind Sie sicher, dass Sie diesen Dienstleister löschen möchten?"
  },

  logs: {
    addingVendor: "Dienstleister hinzufügen...",
    updatingVendor: "Dienstleister aktualisieren..."
  },

  errors: {
    submit: "Fehler beim Speichern des Dienstleisters",
    addVendor: "Fehler beim Hinzufügen des Dienstleisters",
    updateVendor: "Fehler beim Aktualisieren des Dienstleisters",
    deleteVendor: "Fehler beim Löschen des Dienstleisters",
    loadVendors: "Fehler beim Laden der Dienstleister",
    userOrWeddingNotFound: "Benutzer oder Veranstaltung nicht gefunden"
  },

  search: {
    title: "Dienstleister finden",
    searchPlaceholder: "Nach Dienstleistern suchen",
    locationPlaceholder: "Stadt oder PLZ",
    categoryPlaceholder: "Kategorie auswählen",
    sort: "Sortieren nach",
    sortOptions: {
      relevance: "Relevanz",
      rating: "Bewertung",
      reviews: "Rezensionen",
      distance: "Entfernung",
      name: "Name"
    },
    findVendors: "Dienstleister finden",
    googleShort: "Suchen",
    googlePlaceholder: "Nach einem Dienstleister suchen",
    googleResults: "Suchergebnisse",
    googleNoResults: "Keine Ergebnisse gefunden",
    googleError: "Bei der Suche ist ein Fehler aufgetreten",
    googleErrorShort: "Suchfehler",
    locationRequired: "Bitte geben Sie einen Ort für die Suche ein",
    countries: {
      FR: "🇫🇷 Frankreich",
      BE: "🇧🇪 Belgien",
      CH: "🇨🇭 Schweiz",
      ES: "🇪🇸 Spanien",
      IT: "🇮🇹 Italien",
      DE: "🇩🇪 Deutschland",
      GB: "🇬🇧 Vereinigtes Königreich",
      IE: "🇮🇪 Irland",
      CA: "🇨🇦 Kanada",
      US: "🇺🇸 Vereinigte Staaten",
      AU: "🇦🇺 Australien",
      OTHER: "🌍 Andere"
    },
    filters: {
      title: "Filter",
      category: "Kategorie",
      status: "Status",
      search: "Suchen",
      country: "Land",
      location: "Wo?",
      radius: "Umkreis"
    },
    google: "Google Suche",
    googleLong: "Auf Google suchen (Orte, Unternehmen, etc.)",
    placeholder: "Stadt oder PLZ...",
    noResults: "Keine Ergebnisse gefunden",
    noResultsDescription: "Versuchen Sie, Ihre Suchkriterien zu ändern oder Ihr geografisches Gebiet zu erweitern.",
    reset: "Suche zurücksetzen",
    searching: "Suchen",
    searchingDescription: "Wir suchen nach den besten Dienstleistern...",
    addVendor: "Diesen Dienstleister hinzufügen",
    add: "Hinzufügen",
    site: "Webseite",
    phone: "Telefon",
    resultsCountSingular: "Dienstleister gefunden",
    resultsCountPlural: "Dienstleister gefunden",
    reviews: "Bewertungen",
    recommended: "Empfohlen",
    new: "Neu"
  },
  
  empty: {
    title: "Keine Dienstleister",
    description: "Beginnen Sie mit dem Hinzufügen Ihrer Hochzeitsdienstleister"
  },

  filters: {
    title: "Filter",
    category: "Kategorie",
    status: "Status",
    all: "Alle",
    group: "Gruppe",
    search: "Dienstleister suchen",
    events: "Veranstaltungen",
    clear: "Filter löschen",
    apply: "Anwenden",
    previous: "Vorherige",
    next: "Nächste",
    reset: "Zurücksetzen",
    allCategories: "Alle Kategorien"
  },

  groups: {
    family: "Familie",
    friends: "Freunde",
    colleagues: "Kollegen",
    other: "Andere"
  },

  events: {
    ceremony: "Zeremonie",
    reception: "Empfang",
    both: "Beide"
  },

  sort: {
    title: "Sortieren nach",
    options: {
      name: "Name",
      category: "Kategorie",
      status: "Status",
      price: "Preis",
      notes: "Notizen"
    }
  },

  modal: {
    title: "Dienstleister-Details",
    readOnly: "Nur lesen",
    edit: "Bearbeiten",
    share: "Teilen",
    personalInfo: "Persönliche Informationen",
    companyInfo: "Firmeninformationen",
    contactInfo: "Kontaktinformationen",
    notes: "Notizen",
    budget: "Budget",
    documents: "Dokumente",
    timeline: "Zeitplan",
    tasks: "Aufgaben",
    reviews: "Bewertungen",
    messages: "Nachrichten",
    payments: "Zahlungen",
    contracts: "Verträge"
  },

  details: {
    contact: "Kontakt",
    pricing: "Preise",
    documents: "Dokumente",
    appointments: "Termine",
    payments: "Zahlungen"
  },

  vendors: {
    filters: {
      status: "Status",
      all: "Alle",
      group: "Gruppe",
      events: "Veranstaltungen"
    },
    status: {
      confirmed: "Bestätigt",
      pending: "Ausstehend",
      declined: "Abgelehnt"
    },
    groups: {
      family: "Familie",
      friends: "Freunde",
      colleagues: "Kollegen",
      other: "Andere"
    },
    events: {
      ceremony: "Zeremonie",
      reception: "Empfang",
      both: "Beide"
    },
    sort: {
      options: {
        name: "Name",
        category: "Kategorie",
        status: "Status",
        price: "Preis",
        notes: "Notizen"
      }
    }
  },

  success: {
    budgetUpdated: "Budget erfolgreich aktualisiert",
    vendorAdded: "Dienstleister erfolgreich hinzugefügt",
    vendorAndBudgetUpdated: "Dienstleister und Budget erfolgreich aktualisiert",
    vendorUpdated: "Dienstleister erfolgreich aktualisiert"
  }
};
